import { gql, LazyQueryResultTuple, useLazyQuery } from "@apollo/client";

import { MetaphoreAssetSyncLog } from "../../../generated/gql/graphql";

const GET_COLLECTION_SYNC_LOG_ASSET_LOGS = gql`
  query GetCollectionSyncLogAssetLogs($collectionSyncLogId: String!) {
    collectionSyncLogAssetLogs(collectionSyncLogId: $collectionSyncLogId) {
      id
      status
      asset
      platform
      server_response
      dateCreated
    }
  }
`;

/**
 * Lazy query for the per-asset sync logs (detailed error log) of one
 * collection sync. Admin only.
 */
export default function useCollectionSyncLogAssetLogs(): LazyQueryResultTuple<
  { collectionSyncLogAssetLogs: MetaphoreAssetSyncLog[] },
  { collectionSyncLogId: string }
> {
  return useLazyQuery(GET_COLLECTION_SYNC_LOG_ASSET_LOGS, {
    fetchPolicy: "network-only",
  });
}
